import { appTypes } from '../constants/action-types'

export const setErrorTextSnackBar = (error) => {
  return {
    type: appTypes.APPREDUCER_ALERT_FAILURE,
    payload: error
  }
}
export const setSuccessTextSnackBar = (text) => {
  return {
    type: appTypes.APPREDUCER_ALERT_SUCCESS,
    payload: text
  }
}
export const setRequestTextSnackBar = () => {
  return {
    type: appTypes.APPREDUCER_ALERT_REQUEST
  }
}
